<div class="form-group" [ngClass]="mb0">
  <label *ngIf="fieldId" [for]="fieldId" class="label text-muted">
    {{label}}
    <span *ngIf="required" class="text-danger">*</span>
  </label>
  <input [attr.id]="cursorInputId" [readOnly]="readOnly" [attr.maxlength]="maxNo" [attr.min]="minNo" [attr.placeholder]="placeHolder"
    [attr.type]="fieldType" [formControl]="fakeControl" autocomplete="off" class="form-control form-control-sm" />
  <app-form-validation [validationErrors]="validationErrors"></app-form-validation>
</div>
